export { SYMBOL_INDEX_VERSION } from './symbol-index-version.js';
export {
  type SymbolIndexParentRow,
  getSymbolIndexParentContextById,
  getSymbolIndexParentContext,
  getSymbolIndexParentId,
  upsertSymbolIndexParentPath,
} from './parent-path.js';
export {
  persistSymbolIndexFileData,
  removeSymbolIndexFileData,
  clearSymbolIndexParentData,
  clearSymbolIndexParentDataBatch,
  parentHasIndexedFile,
} from './file-data-persistence.js';
export { symbolIndexIsPopulated } from './population.js';
